<template>
  <div>
    <b-row class="mt-2">
      <b-col cols="6" class="m-0 p-0 pr-1">
        <b-col cols="12" class="m-0 p-0 pl-1">
          <div class="separador-div">
            <strong>MEDIÇÕES</strong>
          </div>
        </b-col>
        <b-row class="adjust-a">
          <b-col cols="4" class="adjust-b">
            <div class="separador-div">
              <strong>PONTO</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>A</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>B</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>C</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>D</strong>
            </div>
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 1</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[0].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[0].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[0].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[0].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 2</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[1].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[1].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[1].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[1].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 3</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[2].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[2].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[2].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[2].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 4</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[3].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[3].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[3].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[3].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 5</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[4].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[4].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[4].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[4].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 6</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[5].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[5].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[5].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[5].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 7</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[6].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[6].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[6].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[6].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 8</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[7].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[7].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[7].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[7].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 9</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[8].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[8].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[8].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[8].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 10</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[9].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[9].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[9].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[9].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 11</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[10].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[10].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[10].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[10].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 12</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[11].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[11].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[11].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[11].d" />
          </b-col>
        </b-row>
      </b-col>
      <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
      <!-- :::::::::::::::::::::::::      LATERAL ESQUERDA     :::::::::::::::::::::::::: -->
      <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
      <b-col cols="6" class="m-0 p-0 pl-1">
        <b-row class="adjust-a pt-0 mt-0">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 13</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[12].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[12].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[12].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[12].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 14</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[13].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[13].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[13].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[13].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 15</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[14].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[14].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[14].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[14].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 16</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[15].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[15].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[15].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[15].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 17</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[16].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[16].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[16].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[16].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 18</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[17].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[17].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[17].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[17].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 19</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[18].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[18].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[18].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[18].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 20</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[19].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[19].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[19].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[19].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 21</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[20].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[20].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[20].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[20].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 22</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[21].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[21].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[21].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[21].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 23</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[22].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[22].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[22].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[22].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 24</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[23].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[23].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[23].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[23].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 25</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[24].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[24].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[24].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[24].d" />
          </b-col>
        </b-row>
        <b-row class="adjust-a">
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>LINHA 26</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <div class="separador-div">
              <strong>(mm)</strong>
            </div>
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[25].a" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[25].b" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[25].c" />
          </b-col>
          <b-col cols="2" class="adjust-b">
            <b-form-input class="text-center" v-model="medicoes[25].d" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "MedicaoVasoReport",

  data() {
    return {
      medicoes: [
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //0
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //1
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //2
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //3
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //4
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //5
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //6
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //7
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //8
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //9
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //10
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //11
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //12
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //13
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //14
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //15
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //16
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //17
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //18
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //19
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //20
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //21
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //22
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //23
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //24
        { a: "0.0", b: "0.0", c: "0.0", d: "0.0" }, //25
      ],
    };
  },

  methods: {
    update(medicoes) {
      this.medicoes = medicoes;
    },
  },
};
</script>

<style lang="scss" scoped>
#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #ffbf00;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.adjust-a {
  margin: 0;
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.adjust-b {
  margin: 0;
  padding: 0.1rem;
}
</style>
